import { render, staticRenderFns } from "./createPostGroup.vue?vue&type=template&id=89cf2a86&"
import script from "./createPostGroup.vue?vue&type=script&lang=ts&"
export * from "./createPostGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports